export default __webpack_public_path__ + "static/media/26-EXT-(1-1).e9fb987f.jpg";